'use strict';

import { ProjectElement } from '../../../../../app/resources/element/project-element.interface';
import { Subject } from 'rxjs';
import { skip, takeUntil } from 'rxjs/operators';

(function() {
  angular
    .module('specsguardApp')
    .controller('widgetProjectAssignedElementsCtrl', widgetProjectAssignedElementsCtrl);

  widgetProjectAssignedElementsCtrl.$inject = ['Labels', '$scope', 'Auth', 'Constants', '$window',
  'sg2ElementSidebarService', 'sg2ProjectService'];

  function widgetProjectAssignedElementsCtrl (Labels, $scope, Auth, Constants, $window,
    sg2ElementSidebarService, sg2ProjectService) {

    const vm = this;
    vm.LABELS = Labels;

    /** Initialize project. */
    vm.project = JSON.parse(JSON.stringify(sg2ProjectService.get()));

    /** Add lifecycle hook for unsubscribe. */
    const destroy$ = new Subject();

    /** Subscribe to project updates. */
    sg2ProjectService.project$.pipe(
      skip(1),
      takeUntil(destroy$)
    ).subscribe(p => {
      vm.project = JSON.parse(JSON.stringify(p));
      vm.$onInit();
    });

    /** Unsubscribe. */
    vm.$destroy = () => {
      destroy$.next();
      destroy$.complete();
    };

    vm.$onInit = function () {
      vm.statusList =  Constants.getList('STATUS_TYPES');
      vm.requirementTypes = Constants.getList('REQUIREMENT_TYPES');
      vm.modules = vm.project.modules.filter(m => m.active);
      vm.currentUser = Auth.getCurrentUser();
      vm.assignedElements = [];
      vm.openAssignedElement = openAssignedElement;
      vm.setElementStatus = setStatus;
      assignedElements(); // let's gather all the elements assigned the currentUser

      defineRequirementType();
    };

    /**
     * Based on the Element status_.id we need ot set the status object
     */
    const setStatus = (statusId) => vm.statusList.find((status) => status._id === statusId);

    /**
     * FilterModules is used to make sure we're getting all active modules (with elements).
     *
     * @deprecated
     */
    const filterModules = () =>  {
      let modules = vm.project.modules;
      modules = vm.modFilter.filterInactive(modules);
      modules = vm.modFilter.removeModulesWithoutElements(modules, 'submodules', 'elements', true);
      return modules;
    };

    /**
     * Based on the currentUser we can assign the elements accordingly.
     */
    const assignedElements = () => {
      vm.modules.forEach((projectModule) => {
        projectModule.submodules.forEach((submodule) => {
          submodule.elements.forEach((element) => {
            if (vm.currentUser._id === element.assignedToUserId) {

              if (defineElementType(element)) {
                const { area, building, cluster } = defineElementType(element)[0];
                element.area = area;
                element.building = building;
                element.cluster = cluster;
              }

              vm.assignedElements.push(element);
            }
          });
        });
      });
    };

    // Proper values for the requirement constants
    const defineRequirementType = () => {
      vm.assignedElements.forEach((assignedElement) => {
        for (const requirement of vm.requirementTypes) {
          if (requirement._id === assignedElement.requirementType) {
            assignedElement.requirementObject = requirement;
          }
        }

        return assignedElement;
      });

    };

    const defineElementType = (elm) => {
      let elmObject = {};

      const {
        basicAreaElementId,
        constructionId,
      } = elm;

      if (typeof basicAreaElementId !== 'undefined') {
        const elementArea = getElementArea(constructionId);
        return elmObject = Object.keys(elementArea).length
          ? elementArea
          : false;
      }

      return false;
    };

    const getElementArea = (constructionId: string) => {
      let elmData = {};

      vm.project.buildings.forEach((building) => {
        building.clusters.forEach((cluster) => {
          if (cluster.active) {
            cluster.areas.forEach((area) => {
              if (area.active && area._id === constructionId) {
                elmData = [{area, cluster, building}];
              }
            });
          }
        });
      });

      return elmData;
    };

    /**
     * Open element in sidebar.
     *
     * @param selectedElement The selected element.
     */
    const openAssignedElement = (selectedElement: ProjectElement): void => {
      sg2ElementSidebarService.open(selectedElement);
    };
  }
})();
